<template>
    <div>
        <!-- Modal contact -->
        <modal name="modal-form-contact" height="auto" :scrollable="true" :adaptive="true">
            <div class="p-4">
                <div class="mb-4 pb-4 border-b flex items-center justify-between text-2xl">
                    <h1 class="font-bold">Nous contacter</h1>
                    <button @click="$modal.hide('modal-form-contact')">
                        <i class="fas fa-times text-red-500"></i>
                    </button>
                </div>

                <div>
                    <div class="font-bold text-sm mb-0.5">Sujet</div>
                    <select v-model="form.motif" class="w-full p-1.5 border focus:outline-none rounded text-sm">
                        <option v-for="(motif, motifIndex) in motifs" :key="'contact-motif-' + motifIndex" :value="motif.value">
                            {{ motif.label }}
                        </option>
                    </select>
                </div>

                <div class="mt-4">
                    <div class="font-bold text-sm mb-0.5">Votre adresse email</div>
                    <input v-model="form.email" type="text" class="w-full p-1.5 border focus:outline-none rounded text-sm" />
                </div>

                <div class="mt-4">
                    <div class="font-bold text-sm mb-0.5">Message</div>
                    <textarea v-model="form.message" rows="5" class="w-full p-1.5 border focus:outline-none rounded text-sm"></textarea>
                </div>

                <button @click="sendMessage" :disabled="loadingSend" class="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 duration-200 text-white rounded text-sm font-bold">
                    <spinner v-if="loadingSend" :size="10" />
                    <template v-if="!loadingSend">
                        <i class="fas fa-check mr-1"></i> Envoyer
                    </template>
                </button>
            </div>
        </modal>

        <sav-template name="contact">
            <div class="mt-10 lg:mt-40 container mx-auto lg:px-4 md:px-0">
                <h1 class="font-bold text-4xl" data-aos="fade-up" data-aos-delay="50">Nous contacter</h1>
                <h2 class="text-xl font-light mt-10" data-aos="fade-up" data-aos-delay="150">Sélectionnez le motif de votre demande :</h2>
                <div class="mt-4" data-aos="fade-up" data-aos-delay="250">
                    <div class="border p-4 rounded shadow mt-2">
                        <div @click="selectedTab = selectedTab == 'dossier' ? null : 'dossier'" class="flex items-center justify-between gap-2 hover:text-emerald-600 duration-200 cursor-pointer font-semibold">
                            <div>Avancement d'un dossier SAV</div>
                            <template v-if="selectedTab != 'dossier'">
                                <i class="fas fa-chevron-right"></i>
                            </template>
                            <template v-else>
                                <i class="fas fa-chevron-down"></i>
                            </template>
                        </div>
                        <div v-if="selectedTab == 'dossier'" class="border-t pt-2 mt-2">
                            <div class="flex justify-center">
                                <assistance-suivi-dossier />
                            </div>
                            <!-- <div>
                                Districloud est une plateforme de mise en relation entre clients et prestataires.<br />
                                Nous ne gérons ni le suivi ni l’exécution des dossiers.<br />
                                Pour toute question sur l’avancement, merci de vous adresser directement au fournisseur.
                            </div> -->
                        </div>
                    </div>
                    <div class="border p-4 rounded shadow mt-2">
                        <div @click="selectedTab = selectedTab == 'utilisation' ? null : 'utilisation'" class="flex items-center justify-between gap-2 hover:text-emerald-600 duration-200 cursor-pointer font-semibold">
                            <div>Problème d'utilisation du site</div>
                            <template v-if="selectedTab != 'utilisation'">
                                <i class="fas fa-chevron-right"></i>
                            </template>
                            <template v-else>
                                <i class="fas fa-chevron-down"></i>
                            </template>
                        </div>
                        <div v-if="selectedTab == 'utilisation'" class="border-t pt-2 mt-2">
                            <div class="bg-orange-100 p-4 rounded mt-1 mb-3">
                                <span class="text-orange-700"><i class="fas fa-exclamation-triangle mr-1"></i> <b>Nous n’assurons pas le traitement des dossiers SAV.</b><br /></span>
                                Notre rôle se limite à fournir une plateforme de mise en relation entre les clients et les prestataires.<br />
                                Pour toute question relative à votre dossier SAV, nous vous invitons à contacter directement votre fournisseur.
                            </div>
                            Pour toutes questions ou préoccupations concernant l'utilisation du logiciel, vous pouvez nous contacter en cliquant sur le bouton suivant: <button @click="form.motif = selectedTab; $modal.show('modal-form-contact')" class="px-2 py-1 bg-emerald-200 hover:bg-emerald-300 duration-200 rounded text-xs"><i class="fas fa-comments mr-1"></i> Nous contacter</button>
                        </div>
                    </div>
                    <div class="border p-4 rounded shadow mt-2">
                        <div @click="selectedTab = selectedTab == 'connexion' ? null : 'connexion'" class="flex items-center justify-between gap-2 hover:text-emerald-600 duration-200 cursor-pointer font-semibold">
                            <div>Je n'arrive pas à me connecter</div>
                            <template v-if="selectedTab != 'connexion'">
                                <i class="fas fa-chevron-right"></i>
                            </template>
                            <template v-else>
                                <i class="fas fa-chevron-down"></i>
                            </template>
                        </div>
                        <div v-if="selectedTab == 'connexion'" class="border-t pt-2 mt-2">
                            <div class="bg-orange-100 p-4 rounded mt-1 mb-3">
                                <span class="text-orange-700"><i class="fas fa-exclamation-triangle mr-1"></i> <b>Nous n’assurons pas le traitement des dossiers SAV.</b><br /></span>
                                Notre rôle se limite à fournir une plateforme de mise en relation entre les clients et les prestataires.<br />
                                Pour toute question relative à votre dossier SAV, nous vous invitons à contacter directement votre fournisseur.
                            </div>
                            <div>
                                <div class="font-bold">1. Avez-vous fait votre demande d'inscription sur notre portail ?</div>
                                <div>Si vous n'avez pas fait votre demande, rendez-vous sur <a class="text-blue-500 underline" href="https://auth.districloud.net/inscription">https://auth.districloud.net/inscription</a></div>
                            </div>
                            <div class="mt-4">
                                <div class="font-bold">2. Votre compte est-il validé par nos administrateurs ?</div>
                                <div>Il se peut que votre compte ne soit pas encore validé par nos administrateurs.<br />Assurez-vous d'avoir reçu un email de confirmation vous donnant accès à la plateforme.</div>
                            </div>
                            <div class="mt-4">
                                <div class="font-bold">3. Avez-vous confirmé le code de validation à votre première connexion ?</div>
                                <div>Lorsqu'un nouvel appareil se connecte sur votre compte, il faut saisir le code de validation envoyé sur votre adresse email.</div>
                                <div>Pensez à vérifier vos spams si vous ne trouvez pas l'e-mail.</div>
                            </div>
                            <div class="mt-4">
                                <div class="font-bold">4. Vous souhaitez ajouté une nouvelle adresse email ?</div>
                                <div>Il faut refaire une demande d'inscription. Rendez-vous sur <a class="text-blue-500 underline" href="https://auth.districloud.net/inscription">https://auth.districloud.net/inscription</a></div>
                            </div>
                            <div class="mt-4">
                                <div class="font-bold">5. Vous avez perdu votre mot de passe ?</div>
                                <div>Vous pouvez réinitialiser votre mot de passe depuis <a class="text-blue-500 underline" href="https://auth.districloud.net/mot-de-passe-oublie">https://auth.districloud.net/mot-de-passe-oublie</a></div>
                            </div>
                            <div class="mt-4">
                                <div class="font-bold">6. Vous n'avez trouvé aucune solution ?</div>
                                <div>Vous pouvez nous contacter en cliquant sur le bouton suivant: <button @click="form.motif = selectedTab; $modal.show('modal-form-contact')" class="px-2 py-1 bg-emerald-200 hover:bg-emerald-300 duration-200 rounded text-xs"><i class="fas fa-comments mr-1"></i> Nous contacter</button></div>
                            </div>
                        </div>
                    </div>
                    <div class="border p-4 rounded shadow mt-2">
                        <div @click="selectedTab = selectedTab == 'rgpd' ? null : 'rgpd'" class="flex items-center justify-between gap-2 hover:text-emerald-600 duration-200 cursor-pointer font-semibold">
                            <div>Réglementation liée à la donnée (RGPD)</div>
                            <template v-if="selectedTab != 'rgpd'">
                                <i class="fas fa-chevron-right"></i>
                            </template>
                            <template v-else>
                                <i class="fas fa-chevron-down"></i>
                            </template>
                        </div>
                        <div v-if="selectedTab == 'rgpd'" class="border-t pt-2 mt-2">
                            <div class="bg-orange-100 p-4 rounded mt-1 mb-3">
                                <span class="text-orange-700"><i class="fas fa-exclamation-triangle mr-1"></i> <b>Nous n’assurons pas le traitement des dossiers SAV.</b><br /></span>
                                Notre rôle se limite à fournir une plateforme de mise en relation entre les clients et les prestataires.<br />
                                Pour toute question relative à votre dossier SAV, nous vous invitons à contacter directement votre fournisseur.
                            </div>
                            Pour toutes questions concernant vos données, vous pouvez nous contacter en cliquant sur le bouton suivant <button @click="form.motif = selectedTab; $modal.show('modal-form-contact')" class="px-2 py-1 bg-emerald-200 hover:bg-emerald-300 duration-200 rounded text-xs"><i class="fas fa-comments mr-1"></i> Nous contacter</button>
                        </div>
                    </div>
                    <div class="border p-4 rounded shadow mt-2">
                        <div @click="selectedTab = selectedTab == 'commercial' ? null : 'commercial'" class="flex items-center justify-between gap-2 hover:text-emerald-600 duration-200 cursor-pointer font-semibold">
                            <div>Support commercial</div>
                            <template v-if="selectedTab != 'commercial'">
                                <i class="fas fa-chevron-right"></i>
                            </template>
                            <template v-else>
                                <i class="fas fa-chevron-down"></i>
                            </template>
                        </div>
                        <div v-if="selectedTab == 'commercial'" class="border-t pt-2 mt-2">
                            <div class="bg-orange-100 p-4 rounded mt-1 mb-3">
                                <span class="text-orange-700"><i class="fas fa-exclamation-triangle mr-1"></i> <b>Nous n’assurons pas le traitement des dossiers SAV.</b><br /></span>
                                Notre rôle se limite à fournir une plateforme de mise en relation entre les clients et les prestataires.<br />
                                Pour toute question relative à votre dossier SAV, nous vous invitons à contacter directement votre fournisseur.
                            </div>
                            Pour toutes demandes commerciales, Nous contacter en cliquant sur le bouton suivant <button @click="form.motif = selectedTab; $modal.show('modal-form-contact')" class="px-2 py-1 bg-emerald-200 hover:bg-emerald-300 duration-200 rounded text-xs"><i class="fas fa-comments mr-1"></i> Nous contacter</button>
                        </div>
                    </div>
                    <!-- <div class="border p-4 rounded shadow mt-2">
                        <div @click="selectedTab = selectedTab == 'other' ? null : 'other'" class="flex items-center justify-between gap-2 hover:text-emerald-600 duration-200 cursor-pointer font-semibold">
                            <div>Autre demande</div>
                            <template v-if="selectedTab != 'other'">
                                <i class="fas fa-chevron-right"></i>
                            </template>
                            <template v-else>
                                <i class="fas fa-chevron-down"></i>
                            </template>
                        </div>
                        <div v-if="selectedTab == 'other'" class="border-t pt-2 mt-2">
                            Pour toutes autres demandes, Nous contacter en cliquant sur le bouton suivante <button @click="form.motif = selectedTab; $modal.show('modal-form-contact')" class="px-2 py-1 bg-emerald-200 hover:bg-emerald-300 duration-200 rounded text-xs"><i class="fas fa-comments mr-1"></i> Nous contacter</button>
                        </div>
                    </div> -->
                </div>
            </div>
        </sav-template>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import AssistanceSuiviDossier from './AssistanceSuiviDossier.vue'

export default {
    components: {
        AssistanceSuiviDossier
    },
    data() {
        return {
            selectedTab: null,
            motifs: [
                { value: 'utilisation', label: 'Problème d\'utilisation du site Districloud' },
                { value: 'connexion', label: 'Je n\'arrive pas à me connecter' },
                { value: 'rgpd', label: 'Réglementation liée à la donnée (RGPD)' },
                { value: 'commercial', label: 'Support commercial' },
                { value: 'autre', label: 'Autre demande' }
            ],

            form: {
                no_user: 1,
                motif: null,
                email: null,
                message: ''
            },

            loadingSend: false,
        }
    },
    methods: {
        async sendMessage() {
            let endData = JSON.parse(JSON.stringify(this.form))

            let motif = this.motifs.find(motif => motif.value == endData.motif)
            if (motif) {
                this.form.motif = motif.label
            }
            if (!this.form.motif || !this.form.email || !this.form.message) {
                this.$toast.error('Veuillez remplir tous les champs')
                return
            }
            this.loadingSend = true
            let response = await apiService.post('vitrine.send-message', this.form)
            if (response.data.posts.post == 1) {
                this.$modal.hide('modal-form-contact')
                this.$toast.success('Votre message a bien été envoyé')
                this.form.motif = null
                this.form.email = null
                this.form.message = ''
            }
            this.loadingSend = false
        },
    },
    mounted() {
    }
}
</script>


<style>
.modal-content {
  padding: 20px;
  max-height: 90vh;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .modal-content {
    padding: 10px;
    font-size: 14px;
  }
}
</style>